export const types = {
	REQUEST_AUTH_LOADING: "REQUEST_AUTH_LOADING",
	REQUEST_AUTH_SUCCESS: "REQUEST_AUTH_SUCCESS",
	REQUEST_AUTH_FAILURE: "REQUEST_AUTH_FAILURE",
	REQUEST_LOGOUT_SUCCESS: "REQUEST_LOGOUT_SUCCESS",
};
